import { api, unwrap } from '../../lib/api'
import type { Schemas } from '../../lib/api'

/** The signed-in user's profile. */
export type Profile = Schemas['Profile']

/**
 * Reads the signed-in user's profile, ban included.
 * @returns The profile.
 * @throws {ApiError} `unauthorized` once the account is gone.
 */
export function fetchMe(): Promise<Profile> {
  return unwrap(api.GET('/me'))
}

/**
 * Changes the username, at most once every 7 days.
 * @param username - The new username.
 * @returns The updated profile.
 * @throws {ApiError} `username_taken`, `username_reserved`, `username_cooldown` or `username_invalid`.
 */
export function rename(username: string): Promise<Profile> {
  return unwrap(api.PATCH('/me/username', { body: { username } }))
}

/**
 * Downloads everything stored about the account as a JSON file.
 * @throws {ApiError} When the export fails.
 */
export async function exportData(): Promise<void> {
  const data = await unwrap(api.GET('/me/export'))
  const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }))
  const link = document.createElement('a')
  link.href = url
  link.download = 'tarmx-export.json'
  link.click()
  URL.revokeObjectURL(url)
}

/**
 * Deletes the account. Its messages stay, signed "deleted user".
 * @throws {ApiError} When the deletion fails.
 */
export async function deleteAccount(): Promise<void> {
  await unwrap(api.DELETE('/me'))
}
